import { useLingui } from '@lingui/react/macro';
import type { FC } from 'react';
import { Breadcrumb } from '@/base/Breadcrumb';
import { SEO_ORIGIN } from '@/base/constants';
import { PageMeta } from '@/base/PageMeta';
import { useSettings } from '@/settings/api';
import { LandingLayout } from '../landing/LandingLayout';
import { TradeTopCryptocurrencies } from '../landing/TradeTopCryptocurrencies';
import MarketPageBuyHeader from './MarketPageBuyHeader';
import { MarketSection } from './MarketSection';

export const MarketsPage: FC<{ type: 'buy' | 'price' }> = ({ type }) => {
  const { t } = useLingui();
  const [{ language }] = useSettings();
  const section = type === 'buy' ? 'buy-and-sell' : 'price';

  return (
    <LandingLayout>
      <PageMeta
        title={type === 'buy' ? t`Buy & Sell Crypto` : t`Crypto Prices`}
        description={
          type === 'buy'
            ? t`Buy and sell crypto on IQX — Iraq's first crypto exchange. Browse all available cryptocurrencies.`
            : t`Live cryptocurrency prices and market data on IQX — Iraq's first crypto exchange.`
        }
        localizedPath={`/${section}`}
      />
      <div className="bg-background-disabled/40">
        <Breadcrumb
          className="w-full max-w-desktop mx-auto px-3"
          items={[
            { name: t`Home`, url: `${SEO_ORIGIN}/${language}` },
            {
              name: type === 'buy' ? t`Buy & Sell` : t`Prices`,
              url: `${SEO_ORIGIN}/${language}/${section}`,
            },
          ]}
        />
      </div>
      {type === 'buy' && <MarketPageBuyHeader />}
      <main className="contents">
        <TradeTopCryptocurrencies hideViewAll className="!border-none" />
        <MarketSection className="pb-20 desktop:pb-24" />
      </main>
    </LandingLayout>
  );
};
